import React from 'react';
import { Card, Tag, Avatar, Button } from 'antd';
import { ClockCircleOutlined, BookOutlined, UserOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

export const COURSE_THUMBNAILS = {
  'sale-ban-hang-tu-van': '/images/courses/anh_module_sale.png',
  'marketing-nha-thuoc': '/images/courses/marketing-nha-thuoc.jpg',
  'cong-nghe-ai': '/images/courses/cong-nghe-ai.jpg',
  'van-hanh-nha-thuoc': '/images/courses/van-hanh-tai-chinh.jpg',
  'nhan-su-nha-thuoc': '/images/courses/nhan-su-nha-thuoc.jpg',
  'chuyen-mon-duoc': '/images/courses/chuyen-mon-duoc.jpg',
  'phap-ly-thu-tuc': '/images/courses/phap-ly-thu-tuc.jpg',
};

export function CourseCard({ course }) {
  const navigate = useNavigate();

  const getLevelColor = (level) => {
    switch (level?.toUpperCase()) {
      case 'BEGINNER':
        return 'green';
      case 'INTERMEDIATE':
        return 'blue';
      case 'ADVANCED':
        return 'orange';
      default:
        return 'default';
    }
  };

  const getLevelText = (level) => {
    switch (level?.toUpperCase()) {
      case 'BEGINNER':
        return 'Cơ bản';
      case 'INTERMEDIATE':
        return 'Trung cấp';
      case 'ADVANCED':
        return 'Nâng cao';
      default:
        return 'Mọi cấp độ';
    }
  };

  const thumbnailSrc =
    COURSE_THUMBNAILS[course.slug] ||
    course.thumbnail ||
    '/images/courses/anh_module_sale.png';

  return (
    <Card
      hoverable
      className="hover-card"
      onClick={() => navigate(`/courses/${course.slug || course.id}`)}
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 10,
        overflow: 'hidden',
        border: '1px solid #e2e8f0',
        cursor: 'pointer',
        transition: 'all 0.25s ease',
      }}
      styles={{
        body: {
          padding: 18,
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        },
      }}
      cover={
        <div style={{ position: 'relative', height: 180, overflow: 'hidden', background: '#004724' }}>
          <img
            alt={course.title}
            src={thumbnailSrc}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = '/images/courses/anh_module_sale.png';
            }}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 0.3s ease',
            }}
          />
          {course.category && (
            <div style={{ position: 'absolute', top: 12, left: 12 }}>
              <Tag color={course.category.color || '#005b2f'} style={{ fontWeight: 600, border: 'none' }}>
                {course.category.name}
              </Tag>
            </div>
          )}
        </div>
      }
    >
      {/* Level and Stats */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <Tag color={getLevelColor(course.level)} style={{ margin: 0 }}>
          {getLevelText(course.level)}
        </Tag>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, fontSize: 12, color: '#64748b' }}>
          <span>
            <BookOutlined /> {course.totalLessons || 0} bài học
          </span>
          <span>
            <ClockCircleOutlined /> {course.estimatedHours || 2}h
          </span>
        </div>
      </div>

      {/* Title */}
      <h3
        style={{
          fontSize: 16,
          fontWeight: 700,
          color: '#0f172a',
          lineHeight: 1.4,
          marginBottom: 8,
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          minHeight: 44,
        }}
      >
        {course.title}
      </h3>

      {/* Short Description */}
      <p
        style={{
          fontSize: 13,
          color: '#64748b',
          lineHeight: 1.5,
          marginBottom: 16,
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          flex: 1,
        }}
      >
        {course.shortDescription}
      </p>

      {/* Instructor & Action */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: 12,
          borderTop: '1px solid #f1f5f9',
          marginTop: 'auto',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Avatar
            src={course.instructor?.avatar || '/images/the-thao-pharma-logo.jpg'}
            icon={!course.instructor?.avatar && <UserOutlined />}
            size="small"
            style={{ backgroundColor: '#005537' }}
          />
          <span style={{ fontSize: 12, color: '#475569', fontWeight: 600 }}>
            {course.instructor?.fullName || 'Thế Thảo Pharma'}
          </span>
        </div>

        <Button
          type="link"
          style={{ padding: 0, fontSize: 13, fontWeight: 600, color: '#005537' }}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/courses/${course.slug || course.id}`);
          }}
        >
          Xem khóa học <ArrowRightOutlined />
        </Button>
      </div>
    </Card>
  );
}
